import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-sun-large.tsx
/**
* icon.24.sun.large
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTEyIDE4YS41LjUgMCAwIDEgLjUuNXYyYS41LjUgMCAwIDEtMSAwdi0yYS41LjUgMCAwIDEgLjUtLjVtLTQuOTUtMS43NmEuNS41IDAgMCAxIC43MDguNzA3bC0xLjQxNCAxLjQxNGEuNS41IDAgMSAxLS43MDctLjcwN3ptOS4xOTMgMGEuNS41IDAgMCAxIC43MDcgMGwxLjQxNCAxLjQxM2EuNTAxLjUwMSAwIDAgMS0uNzA3LjcwOGwtMS40MTQtMS40MTVhLjUuNSAwIDAgMSAwLS43MDdNMTIgNy41YTQuNSA0LjUgMCAxIDEgMCA5IDQuNSA0LjUgMCAwIDEgMC05bTAgMWEzLjUgMy41IDAgMSAwIDAgNyAzLjUgMy41IDAgMCAwIDAtN20tNi40OTkgMi45OTdhLjUuNSAwIDAgMSAwIDFoLTJhLjUuNSAwIDAgMSAwLTF6bTE0Ljk5OSAwYS41LjUgMCAwIDEgMCAxaC0yYS41LjUgMCAwIDEgMC0xem0tMi44NDMtNS44NjNhLjUuNSAwIDAgMSAuNzA3LjcwN0wxNi45NSA3Ljc1NWEuNS41IDAgMCAxLS43MDctLjcwN3ptLTEyLjAyLS4wMDFhLjUuNSAwIDAgMSAuNzA3IDBsMS40MTQgMS40MTRhLjUuNSAwIDAgMS0uNzA3LjcwN0w1LjYzNyA2LjM0YS41LjUgMCAwIDEgMC0uNzA3TTEyIDNhLjUuNSAwIDAgMSAuNS41djJhLjUuNSAwIDAgMS0xIDB2LTJBLjUuNSAwIDAgMSAxMiAzIi8+PC9zdmc+)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=26677-58826
*/
const Icon24SunLarge = memo(function Icon24SunLarge(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24L",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M12 18a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2a.5.5 0 0 1 .5-.5m-4.95-1.76a.5.5 0 0 1 .708.707l-1.414 1.414a.5.5 0 1 1-.707-.707zm9.193 0a.5.5 0 0 1 .707 0l1.414 1.413a.501.501 0 0 1-.707.708l-1.414-1.415a.5.5 0 0 1 0-.707M12 7.5a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9m0 1a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7m-6.499 2.997a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm14.999 0a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm-2.843-5.863a.5.5 0 0 1 .707.707L16.95 7.755a.5.5 0 0 1-.707-.707zm-12.02-.001a.5.5 0 0 1 .707 0l1.414 1.414a.5.5 0 0 1-.707.707L5.637 6.34a.5.5 0 0 1 0-.707M12 3a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 12 3"
		})
	});
});
//#endregion
export { Icon24SunLarge };

//# sourceMappingURL=icon-24-sun-large.js.map